import { ApiClassification, ApiProject } from "@incendium/api";
import { audienceService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchClassifications = async (project: ApiProject) => {
  const classifications = await audienceService.audienceServiceListClassifications({
    projectId: project.id as number,
  });
  return classifications.results || [];
};

export const useClassifications = () => {
  const { state, setState, loading, refetch } = useProjectSharedState<ApiClassification[]>(
    "classifications",
    [],
    fetchClassifications
  );

  return {
    classifications: state,
    setClassifications: setState,
    refetchClassifications: refetch,
    loading,
  };
};
